import { render, staticRenderFns } from "./taxNormalWagesList.vue?vue&type=template&id=1250519a&scoped=true&"
import script from "./taxNormalWagesList.vue?vue&type=script&lang=js&"
export * from "./taxNormalWagesList.vue?vue&type=script&lang=js&"
import style0 from "./taxNormalWagesList.vue?vue&type=style&index=0&id=1250519a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1250519a",
  null
  
)

export default component.exports